import React, { useState, useEffect } from 'react'
import { DialogContent, Dialog } from '@mui/material'
import styled from 'styled-components'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import parseVideoUrl from 'services/parseVideoUrl'

export default function VideoPopUp({open, onOpenChange, video}) {
  const [openDialog, setOpenDialog] = useState(false)

  function closeDialog() {
    setOpenDialog(false)
    onOpenChange(false)
  }

  useEffect(() => {
    if (open) {
      setOpenDialog(true)
    }
  }, [open])

  return (
    <Dialog.Stylesheet
      fullScreen
      open={openDialog}
      disableEnforceFocus
    >
      <VideoPopUp.Content style={{paddingTop: 40}}>
        <ArrowBackIcon onClick={() => {closeDialog()}} />
        <div className="video">
          <iframe
            src={parseVideoUrl(video)}
            title="Exercise Video"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
            allowFullScreen
          />
        </div>

      </VideoPopUp.Content>
    </Dialog.Stylesheet>
  )
}

Dialog.Stylesheet = styled(Dialog)``

VideoPopUp.Content = styled(DialogContent)`

  margin: 0 auto;
  .video {
    margin-top: 2rem;
    iframe {
      height: 95vh;
      width: 90vw;

    }
  }
`

VideoPopUp.Stylesheet = styled.div`
  .MuiToolbar-root {
    justify-content: flex-start;
  }
`
